export const fixedSelectCheck = (value, valueSpec) => {
  if (!value) {
    return false;
  }
  if (!valueSpec || !valueSpec.enums) {
    return false;
  }
  if (valueSpec.enums.indexOf(value) === -1) {
    return false;
  }
  return true;
};
